import {
  Checkbox,
  FormControl,
  FormLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { ChevronDown } from 'lucide-react'
import { useStyles } from './style'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const ALL_USERS_OPTION = { id: 0, name: 'TODOS' }

export function UsersSelect({ onFiltered, initialUsers, excludeId, label }) {
  const [users, setUsers] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [rawUsersData, setRawUsersData] = useState([])
  const classes = useStyles()

  const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    },
    className: classes.menuList 
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  // Permite que o menu seja exibido mesmo se o valor for uma string vazia
  getContentAnchorEl: null ,
}

  useEffect(() => {
    async function fetchData() {
      await loadUsers()
    }
    fetchData() // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0 &&
      selectedIds.length === 0
    ) {
      const initialSelectedIds = initialUsers
        .map(initUser => users.find(u => u.id === initUser.id)?.id)
        .filter(Boolean)

      if (initialSelectedIds.length > 0) {
        setSelectedIds(initialSelectedIds)
      } else {
        // Se não há usuários iniciais (nova criação), auto-selecionar usuários com addToNewDepartments = true
        const autoSelectedIds = rawUsersData
          .filter(u => u.addToNewDepartments === true || u.addToNewDepartments === 'true')
          .map(u => u.id)
          .filter(Boolean)
        
        if (autoSelectedIds.length > 0) {
          setSelectedIds(autoSelectedIds)
          const autoSelectedUsers = users.filter(u => autoSelectedIds.includes(u.id))
          onFiltered(autoSelectedUsers)
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users, rawUsersData])

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`)
      let userList = data.map(u => ({ id: u.id, name: u.name }))
      if (excludeId) {
        userList = userList.filter(user => user.id !== excludeId)
      }
      setUsers(userList)
      setRawUsersData(data)
    } catch (err) {
      toastError(err)
    }
  }

  const handleChange = event => {
    const {
      target: { value: nextSelectedIds }
    } = event

    const allUserIds = users.map(u => u.id)
    const justClickedAll = nextSelectedIds.includes(ALL_USERS_OPTION.id)

    if (justClickedAll) {
      if (selectedIds.length === users.length) {
        // All selected, so unselect all
        setSelectedIds([])
        onFiltered([])
      } else {
        // Not all selected, so select all
        setSelectedIds(allUserIds)
        onFiltered(users)
      }
    } else {
      // "All" was not clicked, so it's a normal selection
      setSelectedIds(nextSelectedIds)
      onFiltered(users.filter(u => nextSelectedIds.includes(u.id)))
    }
  }

  // NOVA FUNÇÃO: Renderiza apenas o nome dos usuários separados por vírgula
  const renderSelectedNames = selectedIdsFromSelect => {
    const selectedUserObjects = users.filter(user =>
      selectedIdsFromSelect.includes(user.id)
    )
    return selectedUserObjects.map(user => user.name).join(', ')
  }

  const menuOptions = [ALL_USERS_OPTION, ...users]

  return (
    <FormControl fullWidth className={classes.formControl}>
      <FormLabel id={label}>{label}</FormLabel>
      <Select
        labelId={label}
        id={`${label}-select`}
        multiple
        value={selectedIds}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={renderSelectedNames}
        MenuProps={MenuProps}
        size="small"
        className={classes.select}
        classes={{icon: classes.iconChevronDown}}
        IconComponent={ChevronDown}
      >
        {menuOptions.map(option => (
          <MenuItem
            key={option.id}
            value={option.id}
            className={classes.menuItem}
          >
            <Checkbox
              checked={
                option.id === ALL_USERS_OPTION.id
                  ? selectedIds.length === users.length && users.length > 0
                  : selectedIds.includes(option.id)
              }
              className={classes.checkbox}
            />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
